import { Injectable } from '@angular/core';
import {ConfigurationService} from '../Configuration/configuration-service';
import {DataType, IPublisher} from './ipublisher';
import {Observable} from 'rxjs';
import {IPublisherServiceInitializer} from './ipublisher-service-initializer';
import {IPublisherInitializer} from './ipublisher-initializer';

@Injectable({
  providedIn: 'root'
})
export class PublisherService implements IPublisherInitializer {

  private publishers: IPublisher[];
  private caller: IPublisherServiceInitializer;
  private publisherToInitialize = 0;

  constructor(protected configurationService: ConfigurationService) {
  }

  public initialize(caller: IPublisherServiceInitializer): void {
    this.caller = caller;
    this.configurationService.loadPublisher(this);
  }

  /**
   * Publishers loaded
   * @param publishers array of publishers. Already initialized
   */
  public onPublisherLoaded(publishers: IPublisher[]): void {
    this.publishers = publishers;
    this.publisherToInitialize = this.publishers.length;
    this.publishers.forEach(publisher => {
      publisher.initialize(this, this.configurationService);
    });
  }

  onPublisherInitialized(): void {
    this.publisherToInitialize--;
    if (this.publisherToInitialize === 0) {
      this.caller.onPublisherServiceInitialized();
    }
  }

  public getPublisher(publisherNumber = 0): IPublisher {
    if (this.publishers.length > publisherNumber + 1) {
      publisherNumber = 0;
    }
    return this.publishers[publisherNumber];
  }
}
